import { render, staticRenderFns } from "./DetailHistoryBroadcastLite.vue?vue&type=template&id=256874d1&"
import script from "./DetailHistoryBroadcastLite.vue?vue&type=script&lang=js&"
export * from "./DetailHistoryBroadcastLite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports